var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 426.5 86",
    style: {
      enableBackground: "new 0 0 426.5 86"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#6933D6;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M151.6,52.4h-5.8V36.8c-2.4-0.3-5.1-0.5-7.6-0.5c-8.1,0-10.4,1.8-10.4,7.1v8.9H122v-10c0-1.5,0.2-2.8,0.5-3.9 c-2.1-1.3-5-2.1-9.2-2.1c-7.1,0-9.4,1.8-9.4,7.1v8.9h-5.8v-10c0-7.6,4.8-10.9,15-10.9c5.6,0,9.6,1.3,12.1,3c2.5-2,6.6-3,12.5-3 c5.1,0,11.1,0.8,13.8,1.6C151.6,33.2,151.6,52.4,151.6,52.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M187.1,51.6c-1.7,0.5-7.8,1.6-13.6,1.6c-12.4,0-17-3-17-10.9c0-7.1,4.3-10.9,15.9-10.9 c10.3,0,17.1,2.8,15.9,12.7h-25.8c0.7,3.5,3.6,4.4,11,4.4c6.7,0,11.9-0.8,13.6-1.5L187.1,51.6L187.1,51.6z M182.6,40.5 c0-3-3.6-4.3-10.3-4.3c-6.1,0-9.1,1.1-9.8,4.3H182.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M230.8,25.2h5.8v4.1h-5.8V25.2z M230.8,32.5h5.8v19.9h-5.8V32.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M270.5,49.8c-2.6,2.3-6,3.4-12.6,3.4c-11,0-15.6-4.3-15.6-10.9c0-6.5,4.7-10.9,15.6-10.9 c6.1,0,12.7,0.6,18.4,1.6v19.2h-5.8V49.8z M259.3,48.5c8.5,0,11.2-2.3,11.2-6.9v-4.4c-1.5-0.3-5.9-0.8-11.2-0.8 c-8.2,0-11.2,1.7-11.2,6C248.1,46.6,251.1,48.5,259.3,48.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M282.4,25.2h5.8v6.9c3-0.4,6.5-0.6,8.9-0.6c12.5,0,17.1,3,17.1,10.9s-4.6,10.9-17.1,10.9 c-4.3,0-12.1-0.8-14.7-1.6L282.4,25.2L282.4,25.2z M288.2,47.9c2.8,0.3,6.1,0.5,8.9,0.5c8.6,0,11.3-1.5,11.3-6c0-4.6-2.6-6-11.3-6 c-2.7,0-6.1,0.2-8.9,0.5V47.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M224.4,51.6c-2.6,0.8-10.3,1.6-14.7,1.6c-12.5,0-17.1-3-17.1-10.9s4.6-10.9,17.1-10.9c2.3,0,5.9,0.2,8.9,0.6 v-6.9h5.8C224.4,25.2,224.4,51.6,224.4,51.6z M218.6,36.9c-2.8-0.3-6.2-0.5-8.9-0.5c-8.7,0-11.3,1.5-11.3,6c0,4.5,2.7,6,11.3,6 c2.8,0,6.1-0.2,8.9-0.5V36.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M346.5,49.8c-2.6,2.3-6,3.4-12.6,3.4c-11,0-15.6-4.3-15.6-10.9c0-6.5,4.7-10.9,15.6-10.9 c6.1,0,12.7,0.6,18.4,1.6v19.2h-5.8V49.8z M335.3,48.5c8.5,0,11.2-2.3,11.2-6.9v-4.4c-1.5-0.3-5.9-0.8-11.2-0.8 c-8.2,0-11.2,1.7-11.2,6C324.1,46.6,327.1,48.5,335.3,48.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M358.5,32.5h29.4v3.4l-19.7,11.9h19.7v4.6h-30.1v-3.5l19.8-11.8h-19.1V32.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M420.7,49.8c-2.6,2.3-6,3.4-12.6,3.4c-11,0-15.6-4.3-15.6-10.9c0-6.5,4.7-10.9,15.6-10.9 c6.1,0,12.7,0.6,18.4,1.6v19.2h-5.8L420.7,49.8L420.7,49.8z M409.5,48.5c8.5,0,11.2-2.3,11.2-6.9v-4.4c-1.5-0.3-5.9-0.8-11.2-0.8 c-8.2,0-11.2,1.7-11.2,6C398.2,46.6,401.3,48.5,409.5,48.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M78.2,46L61.5,80.1C55.4,92,36.2,84,42.1,72l2.3-4.8c1.5-3.2,1.1-6.8-0.6-9.5c-1.6-2.7-4.5-4.5-7.9-4.6l-3.4,0 c-0.6,0-1.3,0-1.9,0c-9.6-0.1-12.4-9.4-8.2-15.3l1.6-3.4c1.5-3.2,1.1-6.8-0.6-9.5c-1.6-2.7-4.5-4.5-7.9-4.6l-5.2,0 C-4,20.2-3.5,0,12.4,0l37.4,0c3.3,0,6,1.7,7.7,4.1c1.5,2.7,1.7,6.1,0.3,9.1l-9.7,19.7l22.2,0c3.3,0,6,1.7,7.7,4.1 C79.4,39.7,79.7,43,78.2,46z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlue);
export default __webpack_public_path__ + "static/media/logo_blue.b52707a02b37520fac4266b925590791.svg";
export { ForwardRef as ReactComponent };